/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useEffect, useState } from "react";
import { Card, Form, TabContent } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ResponseResult } from "../../apis/response";
import NavBar from "../../components/NavBar/NavBar";
import Pagenate from "../../components/Pagenate/Pagenate";
import Tab from "../../components/Tab/Tab";
import { mypage_tab, pay_sttus_label } from "../../configs/base";
import { getChargingListExport } from "../../stores/actions/charging_action";
import {
  csmsGetApiKey,
  csmsGetChargingList,
} from "../../stores/actions/csms_action";
import {
  mypage_filter_dt,
  mypage_filter_tb,
  tb_point,
} from "../../styles/media-queries";
import { BtnFullGraySquare, MyPageWrap } from "../../styles/themes";
import {
  today,
  monthBefore,
  formatYYYYMMDDHHmmss,
  moneyFormat,
  last_month_end_day,
  last_month_start_day,
} from "../../utils/utils";
import DOWNLOAD_ICON from "../../assets/images/download_icon.png";
import DOWNLOAD_ICON2 from "../../assets/images/download_icon2.png";
import {
  typo_light_blue,
  alert_red,
  status_red,
  white,
  warning_orange,
  text_default,
} from "../../styles/colors";
import ModalAlert from "../../components/Modal/ModalAlert";
import ModalRepay from "../../components/Modal/ModalRepay";
import Footer from "../../components/Footer/Footer2";
import { serverErrAlertMessage } from "../../validations/messages/messages";

// CSMS API는 beginDts/beginDte의 날짜를 KST 기준으로 그대로 읽고(Z는 포맷 검증용일 뿐 실제 UTC 변환이 아님),
// beginDte는 입력한 날짜를 기준으로 서버가 +1일 하여 해당일 전체를 포함시켜준다.
const toChrgrElctcDate = (dateStr) => `${dateStr}T00:00:00.000Z`;

function ChargingListPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useState(useSelector((state) => state.user));
  const params = new URLSearchParams(window.location.search);

  const Month = today("mm") + " 월";
  const LastMonth = monthBefore("mm", 1) + " 월";

  const [Charging, setCharging] = useState([]);
  const [IsCheckAll, setIsCheckAll] = useState(false);
  const [IsCheck, setIsCheck] = useState([]);
  const [SearchStartDate, setSearchStartDate] = useState(
    today("yyyymm") + "-01"
  );
  const [SearchEndDate, setSearchEndDate] = useState(today());

  const [currentPage, setCurrentPage] = useState(
    params.get("currentPage") ?? "1"
  );
  const [totalPage, setTotalPage] = useState();
  const cPage = params.get("currentPage");

  const [modalShow, setModalShow] = useState(false);
  const [ResMsg, setResMsg] = useState();

  const [HasUnpaid, setHasUnpaid] = useState(false);
  const [RepayModalShow, setRepayModalShow] = useState(false);

  const [IsLoading, setIsLoading] = useState(false);

  // 체크박스 관련
  const handleSelectAll = (event) => {
    // 전체선택 체크박스 선택시 전체선택 체크박스 상태 변경 (IsCheckAll)
    const checked = event.target.checked;
    if (checked) {
      setIsCheck(Charging.map((p) => p.id));
    } else {
      setIsCheck([]);
    }

    setIsCheckAll(!IsCheckAll);
  };

  const handleSelectSingle = (event) => {
    // 하위 체크박스 선택시

    if (IsCheckAll) {
      setIsCheckAll(false);
    }

    if (IsCheck.includes(event.target.id)) {
      // 존재
      setIsCheck(IsCheck.filter((value) => value !== event.target.id));
    } else {
      //없음
      setIsCheck([...IsCheck, event.target.id]);
    }

  };
  // 체크박스 관련

  // 기간 검색 관련
  const onClick1MonthHandler = () => {
    setSearchStartDate(last_month_start_day());
    setSearchEndDate(last_month_end_day());
  };

  const onClickThisMonthHandler = () => {
    setSearchStartDate(today("yyyymm") + "-01");
    setSearchEndDate(today());
  };

  const onSearchStartDateChangeHandler = (event) => {
    setSearchStartDate(event.target.value);
  };

  const onSearchEndDateChangeHandler = (event) => {
    setSearchEndDate(event.target.value);
  };
  // 기간 검색 관련

  const onClickSearchDateHandler = () => {
    setIsLoading(true);

    navigate(
      "?currentPage=" +
      1 +
      "&searchStartDt=" +
      SearchStartDate +
      "&searchEndDt=" +
      SearchEndDate
    );
  };

  const onClickExcelDownloadHandler = () => {
    let reqParams = {
      userId: user[0].id,
    };
    if (Charging.length == 0) {
      setModalShow(true);
      setResMsg("충전내역이 존재하지 않습니다.");
      return false;
    }
    if (IsCheck.length == 0) {
      // 전체선택인 경우
      reqParams = {
        ...reqParams,
        ids: 'ALL',
        searchStartDt: SearchStartDate,
        searchEndDt: SearchEndDate
      };
    } else if (IsCheck.length > 0) {
      // 전체선택이 아닌 경우
      reqParams = {
        ...reqParams,
        ids: IsCheck,
      };
    } else {
      setModalShow(true);
      setResMsg("다운로드할 이용내역을 선택해주세요.");

      return false;
    }

    dispatch(getChargingListExport(reqParams)).then((response) => {

      let byteArray = new Uint8Array(response.payload.data.data);


      var a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(
        new Blob([byteArray], { type: "application/octet-stream" })
      );

      a.download = `charging_list.XLSX`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  };

  // 페이지 클릭
  const onClickPageChangeHandler = (page) => {
    setCurrentPage(page);
    navigate("?currentPage=" + page);
  };

  useEffect(() => {
    const fetchChargingList = async () => {
      const tokenResponse = await dispatch(csmsGetApiKey());
      if (!tokenResponse.payload || !tokenResponse.payload.data) {
        alert(serverErrAlertMessage);
        return;
      }
      const csmsToken = tokenResponse.payload.data.accessToken;

      let reqParams = {
        currentPage: currentPage,
        perPage: 10,
        beginDts: toChrgrElctcDate(SearchStartDate),
        beginDte: toChrgrElctcDate(SearchEndDate),
      };

      dispatch(csmsGetChargingList(user[0].id, reqParams, csmsToken)).then((response) => {
        if (response.payload.result === ResponseResult.OK) {
          setCharging(response.payload.data.chrgrElctcList);
          setTotalPage(parseInt(response.payload.data.totPage));
        } else {
          alert(response.payload.msg);
        }
      });

      // 결제 실패로 서비스 이용이 정지되었는지 확인 (미결제 내역 = 결제완료된 충전 중 결제상태가 실패한 건)
      dispatch(
        csmsGetChargingList(
          user[0].id,
          { currentPage: 1, perPage: 1, unPaid: true, elctcSttusEnd: true },
          csmsToken
        )
      ).then((response) => {
        if (response.payload.result === ResponseResult.OK) {
          setHasUnpaid(response.payload.data.totCount > 0);
        } else {
          console.error(response.payload.msg);
        }
      });
    };

    fetchChargingList();
  }, []);

  useEffect(() => {
    const fetchChargingList = async () => {
      const tokenResponse = await dispatch(csmsGetApiKey());
      if (!tokenResponse.payload || !tokenResponse.payload.data) {
        alert(serverErrAlertMessage);
        return;
      }
      const csmsToken = tokenResponse.payload.data.accessToken;

      let reqParams = {
        currentPage: cPage,
        perPage: 10,
        beginDts: toChrgrElctcDate(SearchStartDate),
        beginDte: toChrgrElctcDate(SearchEndDate),
      };

      dispatch(csmsGetChargingList(user[0].id, reqParams, csmsToken)).then((response) => {
        if (response.payload.result === ResponseResult.OK) {
          setCharging(response.payload.data.chrgrElctcList);
          setCurrentPage(parseInt(cPage));
          setTotalPage(parseInt(response.payload.data.totPage));
        } else {
          alert(response.payload.msg);
        }
      });
    };

    fetchChargingList();
  }, [
    currentPage,
    cPage,
    params.get("searchStartDt"),
    params.get("searchEndDt"),
  ]);

  useEffect(() => {
    if (IsCheckAll) {
      // setIsCheck(Charging.map((p) => p.id));
      setIsCheckAll(false);
    } else {
      setIsCheck([]);
    }
  }, [Charging]);


  return (
    <>
      <NavBar />
      <div css={MyPageWrap}>
        <Card>
          <Card.Body>
            <h1>마이페이지</h1>
            <Tab list={mypage_tab} active={0} userId={1}></Tab>
            <TabContent>
              <div className="filter">
                <div css={filterDownWrap}>
                  <button
                    css={[
                      BtnFullGraySquare,
                      css`
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 225.3%;
                        &:hover {
                          img {
                            transition: all 0.5s ease;
                            content: url(${DOWNLOAD_ICON2});
                          }
                        }
                      `,
                    ]}
                    onClick={onClickExcelDownloadHandler}
                  >
                    내역다운로드
                    <img src={DOWNLOAD_ICON} alt="download_icon" />
                  </button>
                </div>
                <div css={filterDayDtWrap}>
                  <button
                    css={[BtnFullGraySquare, filterDayWrap]}
                    onClick={onClick1MonthHandler}
                  >
                    {LastMonth}
                  </button>
                  <button
                    css={[BtnFullGraySquare, filterDayWrap]}
                    onClick={onClickThisMonthHandler}
                  >
                    {Month}
                  </button>
                  <Form.Control
                    value={SearchStartDate}
                    type="date"
                    css={css`
                      margin-right: 10px;
                    `}
                    onChange={onSearchStartDateChangeHandler}
                  />
                  <h1
                    css={css`
                      margin-right: 10px;
                    `}
                  >
                    -
                  </h1>
                  <Form.Control
                    value={SearchEndDate}
                    type="date"
                    css={css`
                      margin-right: 10px;
                    `}
                    onChange={onSearchEndDateChangeHandler}
                  />
                  <button
                    css={[
                      BtnFullGraySquare,
                      css`
                        margin-left: 8px;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 225.3%;
                      `,
                    ]}
                    onClick={onClickSearchDateHandler}
                  >
                    {/* {IsLoading && <span classNamefilter="spinner-border spinner-border-sm mr-1"></span>} */}
                    조회
                  </button>
                </div>
              </div>
              <div className="tb_filter" css={filterDayTbWrap}>
                <button
                  css={[BtnFullGraySquare, filterDayWrap]}
                  onClick={onClick1MonthHandler}
                >
                  {LastMonth}
                </button>
                <button
                  css={[BtnFullGraySquare, filterDayWrap]}
                  onClick={onClickThisMonthHandler}
                >
                  {Month}
                </button>
                <Form.Control
                  value={SearchStartDate}
                  type="date"
                  css={css`
                    margin-right: 10px;
                  `}
                  onChange={onSearchStartDateChangeHandler}
                />
                <h1
                  css={css`
                    margin-right: 10px;
                  `}
                >
                  -
                </h1>
                <Form.Control
                  value={SearchEndDate}
                  type="date"
                  css={css`
                    margin-right: 10px;
                  `}
                  onChange={onSearchEndDateChangeHandler}
                />
                <button
                  css={[
                    BtnFullGraySquare,
                    css`
                      margin-left: 8px;
                      font-weight: 400;
                      font-size: 12px;
                      line-height: 225.3%;
                    `,
                  ]}
                  onClick={onClickSearchDateHandler}
                >
                  {/* {IsLoading && <span className="spinner-border spinner-border-sm mr-1"></span>} */}
                  조회
                </button>
              </div>
              <div
                css={css`
                  overflow-x: auto;
                `}
                className="charging"
              >
                <table
                  className="text-center"
                  css={css`
                    min-width: ${tb_point};
                    width: 100%;
                  `}
                >
                  {/* TODO table 열 넓이 고정 */}
                  <colgroup><col width="15px" /><col width="20%" /><col width="20%" /><col width="15%" /><col width="15%" /><col width="8%" /><col /><col /></colgroup>
                  <thead>
                    <tr>
                      <th>
                        <Form.Check
                          type="checkbox"
                          name="selectAll"
                          id="selectAll"
                          checked={IsCheckAll}
                          onChange={handleSelectAll}
                        />
                      </th>
                      <th>충전 시작</th>
                      <th>충전 종료</th>
                      <th>충전소명</th>
                      <th>충전기 관리번호</th>
                      <th>충전량</th>
                      <th>결제금액</th>
                      <th>결제상태</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Charging.length === 0 ? (
                      <tr>
                        <td colSpan={9}>충전내역이 존재하지 않습니다.</td>
                      </tr>
                    ) : (
                      Charging.map((obj, index) => {
                        return (
                          <tr
                            key={index}
                            css={obj.paySttus === "FAIL" ? failRowWrap : undefined}
                          >
                            <td
                              css={css`
                                width: 1%;
                              `}
                            >
                              <Form.Check
                                type="checkbox"
                                onChange={handleSelectSingle}
                                id={obj.id}
                                checked={
                                  IsCheck.includes(obj.id) ? true : false
                                }
                              />
                            </td>
                            <td>
                              {obj.beginDt
                                ? formatYYYYMMDDHHmmss(obj.beginDt)
                                : "-"}
                            </td>
                            <td>
                              {obj.endDt
                                ? formatYYYYMMDDHHmmss(obj.endDt)
                                : "-"}
                            </td>
                            <td>{obj.stationNm ? obj.stationNm : "-"}</td>
                            <td>{obj.chrgrIdntfr ? obj.chrgrIdntfr : "-"}</td>
                            <td>{obj.elctcQy ? obj.elctcQy : "-"}</td>
                            <td
                              css={css`
                                color: ${typo_light_blue};
                                /* TODO 언더라인 제거 */
                                /* text-decoration-line: underline; */
                              `}
                            >
                              {/* TODO 결제금액란에 포인트 결제 내역도 추가 */}
                              {
                                obj.paidCardPrice
                                  ? moneyFormat(Number(obj.paidCardPrice)) + "원"
                                  : obj.paidPointPrice ? moneyFormat(Number(obj.paidPointPrice)) + "P" : "-"
                              }
                            </td>
                            <td
                              css={
                                obj.paySttus === "FAIL"
                                  ? css`
                                      color: ${status_red};
                                    `
                                  : undefined
                              }
                            >
                              {pay_sttus_label[obj.paySttus] ?? "-"}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </TabContent>
            {totalPage > 1 && (
              <Pagenate
                currentPage={currentPage}
                totalPage={totalPage}
                onClickPageChange={onClickPageChangeHandler}
              />
            )}
            {HasUnpaid && (
              <div css={unpaidBannerWrap}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  css={css`
                    flex-shrink: 0;
                  `}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8ZM8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM7.25 12V10.5H8.75V12H7.25ZM7.25 4V9H8.75V4H7.25Z"
                    fill={warning_orange}
                  />
                </svg>
                <div css={unpaidBannerText}>
                  등록된 결제 수단으로 결제가 이루어지지 않아 서비스 이용이
                  잠시 중단되었습니다. 결제를 완료하시면 정지가 해제됩니다.
                </div>
                <div css={unpaidBannerBtnWrap}>
                  <button
                    css={unpaidBannerBtnOutline}
                    onClick={() => navigate("/mypage/paycard")}
                  >
                    결제 카드 변경
                  </button>
                  <button
                    css={unpaidBannerBtnFull}
                    onClick={() => setRepayModalShow(true)}
                  >
                    결제 재시도
                  </button>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
      <div
        css={css`
          width: 100%;
          height: 100vh;
        `}
      >
        <Footer />
      </div>
      <ModalAlert
        show={modalShow}
        onClickHandler={() => setModalShow(false)}
        oneButtonTitle={"확인"}
        alertContent={ResMsg}
        onHide={() => setModalShow(false)}
      />
      <ModalRepay
        show={RepayModalShow}
        userId={user[0].id}
        onHide={() => setRepayModalShow(false)}
      />
    </>
  );
}

const filterDownWrap = css`
  height: 28px;
  min-width: 100px;
  @media (min-width: ${tb_point}) {
    width: 136px;
  }
`;

const filterDayDtWrap = css`
  height: 28px;
  display: flex;
  ${mypage_filter_tb} {
    display: none;
  }
`;

const filterDayTbWrap = css`
  display: flex;
  ${mypage_filter_dt} {
    display: none;
  }
`;

const filterDayWrap = css`
  margin-right: 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 225.3%;
  min-width: 50px;
`;

const failRowWrap = css`
  background: ${alert_red};
`;

const unpaidBannerWrap = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
  padding: 20px;
  border: 1px solid ${warning_orange};
  border-radius: 10px;
  background: ${alert_red};
`;

const unpaidBannerText = css`
  flex: 1;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.03em;
  vertical-align: middle;
  color: ${text_default};
  text-align: left;
`;

const unpaidBannerBtnWrap = css`
  display: flex;
  gap: 8px;
  margin-left: auto;
`;

const unpaidBannerBtn = css`
  min-width: 120px;
  height: 40px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
`;

const unpaidBannerBtnOutline = css`
  ${unpaidBannerBtn}
  border: 1px solid ${typo_light_blue};
  background: ${white};
  color: ${typo_light_blue};
`;

const unpaidBannerBtnFull = css`
  ${unpaidBannerBtn}
  border: none;
  background: ${typo_light_blue};
  color: ${white};
`;

export default ChargingListPage;
